import mitt from 'mitt';

const emitter = mitt();

const bus = Object.freeze({
    $on: emitter.on.bind(emitter),
    $emit: emitter.emit.bind(emitter),
    $off: emitter.off.bind(emitter),
});

export default bus;
